import * as base64 from "base-64"

type Payload = {
    exp?: number
    [key: string]: any
}

export function getPayload(token: string): Payload {
    const segments = token ? token.split(".") : []

    // a jwt is header.payload.signature, anything else has no payload to read
    if (segments.length !== 3) {
        return {}
    }

    try {
        const payloadBase64 = segments[1].replace(/-/g, "+").replace(/_/g, "/")
        const payloadDecoded = base64.decode(payloadBase64)
        const payloadObject = JSON.parse(payloadDecoded)

        // jwt timestamps are in seconds, everything comparing them against Date.now() needs ms
        if (payloadObject.exp) {
            payloadObject.exp = payloadObject.exp * 1000
        }

        return payloadObject
    } catch {
        // return empty payload in case of an error
        return {}
    }
}
